export const getDefaultValues = (accountDetails) => ({
  SocialManagerAccountToken: accountDetails?.SocialManagerAccountToken || '',
  SocialManagerAccountKey: accountDetails?.SocialManagerAccountKey || '',
});
